import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

const { spacers } = baseVariables;

export const Wrapper = styled.span`
  padding-block-end: ${spacers?.spacers?.[2] ?? '0.5rem'};

  /* DUX-1153 Global Styles overrides:  .t-overline-alt-normal, .t-overline-overlay */
  &.t-overline-alt-normal,
  &.t-overline-overlay {
    line-height: 1;
    display: block;
  }
`;
